<template>
    <div style="padding:1px;">
    </div>
</template>
<script>

export default {
  name: 'SearchCode',
  data () {
    return {
      platform:'',
      appLaunched:false,
      startTime:null,
    }
  },
  mounted () {
    let u = this.$route.query.u;
    this.platform = this.detectPlatform();
    if(this.platform=='PC'){
      window.location.href='/';
    }
    else{
      this.setupVisibilityChecks();
      window.location.href='joyorders://pages/'+u;
      //console.log('test','joyorders://pages/'+u)
      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.src = 'joyorders://pages/'+u;
      document.body.appendChild(iframe);
      this.startTime = Date.now();
      this.startFallbackTimer();
    }
  },
  methods: {
    setupVisibilityChecks() {
        // 标准API：当页面隐藏（如跳转到App）时触发
        document.addEventListener('visibilitychange', function() {
            if (document.hidden) {
                this.appLaunched = true;
                console.log('App可能已成功唤起（页面隐藏）。');
            }
        });
        
        // 备用API：针对部分浏览器
        window.addEventListener('pagehide', function() {
            this.appLaunched = true;
            console.log('App可能已成功唤起（页面卸载）。');
        });
        
        // 监听窗口失去焦点（辅助判断）
        window.addEventListener('blur', function() {
            this.appLaunched = true;
            console.log('App可能已成功唤起（窗口失焦）。');
        });
    },
    startFallbackTimer() {
        const maxWaitTime = 2500;
        const timer = setInterval(()=>{
            const elapsed = Date.now() - this.startTime;
            
            console.log('time',elapsed,this.startTime);
            // 如果超时且未被标记为已唤起，则执行备用方案
            if (elapsed > maxWaitTime && !this.appLaunched) {
                clearInterval(timer);
                this.redirectToStore();
            }
            
            // 如果已被标记为唤起，则清除定时器
            if (this.appLaunched) {
                clearInterval(timer);
            }
        }, 100); // 每100毫秒检查一次
    },
     redirectToStore() {        
        // 根据设备类型跳转到不同的应用商店
        if (this.platform=='iOS') {
            window.location.href = 'https://apps.apple.com/cn/app/joyorders/id6743926892';
        } else if (this.platform=='Android') {
            window.location.href = '/';
        } else {
            // 其他设备跳转到默认页面
            window.location.href = '/';
        }
    },
     detectPlatform() {
        const ua = navigator.userAgent;
        let platform = 'unknown';

        if (/iPhone|iPad|iPod/i.test(ua)) {
            platform = 'iOS';
        }
        else if (/Android/i.test(ua)) {
            platform = 'Android';
        }
        else if (!/Mobi|Android/i.test(ua)) {
            platform = 'PC';
        }

        return platform;
    }
  },
}

</script>
<style scoped lang="scss">
.snatched {
    margin: 0 auto 60px;;
    margin-top: 180px;
    // width: 914px;
    padding: 0 20%;
    text-align: center;
}
    @media screen and (max-width:1375px){
        .snatched {
            padding: 0 15%;
        }
    }
    @media screen and (max-width:1200px){
        .snatched {
            padding: 0 10%;
        }
    }
    @media screen and (max-width:1025px){
        .snatched {
            padding: 0 10px;
            margin-top: 100px;
            .toggleList {
                padding-left: 0 !important;

                .toggle{

                    width: 100%;
                    margin-bottom: 20px;
                }
            }

            .button {
                float: left;
            }

            .pool {
                margin-top: 20px;
                .poolTitle {
                    display: block;
                    width: 250px !important;
                    font-size: 14px;
                }
            }
        }
    }
    @media screen and (max-width:750px){
        .snatched {
            .pool {

                .goods  {

                    .left-content {
                        width: 100%;
                        margin-bottom: 20px;

                        .goodsList {

                            .order-des {
                                float: right !important;
                                width: 50% !important;
                            }
                        }
                    }

                    .right-operation {
                        .mobile-button {
                            width: 268px !important;
                        }
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/qrCode/appredirect.vue